export function useTrimHighlightSnippet() {
  const { $parseStringToDocument } = useNuxtApp()

  return (html: string): string =>
    $parseStringToDocument(normalizeLineBreaks(html), ['clean-highlight-snippet']).body.innerHTML
}
